import { useCookies } from 'vue3-cookies';
const { cookies } = useCookies();
const COOKIE_NAME = 'policyCookie';

const state = () => ({
  name: COOKIE_NAME,
  show: false
});

const getters = {
  shouldShow(state) {
    return state.show;
  },
  getValue(state) {
    const value = cookies.get(state.name);
    if (!value) {
      return undefined;
    }
    return JSON.parse(decodeURIComponent(value));
  }
};

const mutations = {
  setShow(state, value) {
    state.show = value;
  }
};

const actions = {
  checkCookie({ commit, state }) {
    const existing = cookies.get(state.name);
    if (!existing) {
      commit('setShow', true);
    } else {
      commit('setShow', false);
    }
  },
  async acceptCookie({ commit, state }, payload) {
    cookies.set(state.name, encodeURIComponent(JSON.stringify({ datetime: payload.datetime })), '365d');
    commit('setShow', false);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
